import { Box, Grid, Stack, Typography, Button } from "@mui/material";
import PageLayout from "../../components/PageLayout";
import { useNavigate } from "react-router-dom";
import { appConfigs, appRoutes } from "../../constants/ApplicationConstants";
import logo from "../../assets/images/defaults/logo-dark.png"
import { ChevronRight } from '@mui/icons-material';
import logout from "../../assets/images/logout.svg";

export default function LogoutScreen(){

    const navigate= useNavigate();

    function navigateToLoginScreen(){
        navigate(appRoutes.home)
    }

    return(
        <PageLayout header={false} footer={false}>
            <Box>
                <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                    <Grid item xs={4}>
                        <Box marginLeft={10}>
                            <Stack direction="column" justifyContent="space-between" alignItems="flex-start" spacing={12}>
                                <img alt="explore" src={logo} style={{
                                    width: '75%', height: '75%'
                                }} />
                                <Typography variant="h2">You are logged out.</Typography>
                                <Button sx={{ textTransform: 'capitalize' }} onClick={()=>navigateToLoginScreen()} variant="contained" color="primary">Login Again <ChevronRight style={{marginLeft: '1rem'}} /></Button>
                                <Typography color="gray" fontSize={'0.5rem'}>{appConfigs.footerText}</Typography>
                            </Stack>
                        </Box>
                    </Grid>
                    <Grid item xs={8}>
                        <img alt="explore" src={logout} style={{
                            width: '90%', height: '90%'
                        }} />
                    </Grid>
                </Grid>
            </Box>
        </PageLayout>
    )
}